module.exports = __webpack_public_path__ + "46f07fb283a5cd76f3049908927ceb9a.svg";